import React, {useState} from 'react';
import {Box, CssBaseline, List, ListItemButton, ListItemText, Typography, useTheme} from '@mui/material';
import {LanguageOutlined} from '@mui/icons-material';
import Topbar from '../../layout/Topbar';
import SettingsSidebar from '../SettingsSidebar';
import TrackingDomains from './TrackingDomains';
import CloakingDomains from './CloakingDomains';
import {SettingsContentBox, SettingsRoot} from '../General';
import {getSettingsColors, settingsTabsStyles} from '../SettingsDesign';

export function DomainsContent() {
    const [tab, setTab] = useState('tracking');
    const theme = useTheme();
    const colors = getSettingsColors(theme);

    return <Box sx={{maxWidth: 1280, mx: 'auto', px: {xs: 2, md: 4}, py: 3, minWidth: 0, '& .MuiTypography-root': {whiteSpace: 'normal'}}}>
        <Box sx={{mb: 3}}>
            <Typography component="h1" sx={{fontSize: {xs: 24, md: 28}, fontWeight: 700, letterSpacing: '-0.5px'}}>Domains</Typography>
            <Typography sx={{mt: 0.5, color: 'text.secondary', fontSize: 14}}>Manage the domains used for tracking campaigns and hide your referer info.</Typography>
        </Box>
        <Box sx={{display: 'flex', gap: 1.5, bgcolor: colors.inset, borderRadius: '12px', p: {xs: 2, md: 2.5}, mb: 3}}>
            <LanguageOutlined sx={{color: 'primary.main', mt: 0.25, flexShrink: 0}}/>
            <Box sx={{minWidth: 0}}>
                <Typography sx={{fontSize: 14, fontWeight: 600, mb: 0.5}}>Use your own domains for live campaigns</Typography>
                <Typography sx={{fontSize: 13, color: 'text.secondary', lineHeight: 1.7}}>
                    Custom domains help protect your campaign reputation. The shared skrotrack.com and skrocloak.com domains are intended for testing and may be flagged by traffic sources or antivirus software.
                </Typography>
            </Box>
        </Box>
        <Box display="flex" sx={settingsTabsStyles}>
            <List role="tablist" aria-label="Domain type" sx={{display: 'flex', flexDirection: 'row', p: 0, flexShrink: 0}}
                  onKeyDown={event => {
                      let next;
                      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') next = tab === 'tracking' ? 'cloaking' : 'tracking';
                      if (event.key === 'Home') next = 'tracking';
                      if (event.key === 'End') next = 'cloaking';
                      if (next) {
                          event.preventDefault();
                          setTab(next);
                          document.getElementById(`${next}-tab`).focus();
                      }
                  }}>
                {[{value: 'tracking', label: 'Tracking domains'}, {value: 'cloaking', label: 'Cloaking domains'}].map(item =>
                    <ListItemButton key={item.value} component="button" type="button" role="tab"
                                    id={`${item.value}-tab`} aria-controls={`${item.value}-panel`}
                                    selected={tab === item.value} aria-selected={tab === item.value}
                                    tabIndex={tab === item.value ? 0 : -1} onClick={() => setTab(item.value)}
                                    sx={{':hover': {bgcolor: 'background.rowHover'}}}>
                        <ListItemText primary={item.label} sx={{fontSize: 14, px: 2, '& .MuiTypography-root': {whiteSpace: 'nowrap'}}}/>
                    </ListItemButton>
                )}
            </List>
        </Box>
        <Box role="tabpanel" id="tracking-panel" aria-labelledby="tracking-tab" hidden={tab !== 'tracking'}><TrackingDomains/></Box>
        <Box role="tabpanel" id="cloaking-panel" aria-labelledby="cloaking-tab" hidden={tab !== 'cloaking'}><CloakingDomains/></Box>
    </Box>;
}

export default function Domains(props) {
    return <SettingsRoot>
        <CssBaseline/>
        <Topbar/>
        <SettingsSidebar {...props}/>
        <SettingsContentBox sx={{bgcolor: theme => getSettingsColors(theme).canvas}}><DomainsContent/></SettingsContentBox>
    </SettingsRoot>;
}
